var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/emoji-happy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emoji-happy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7498 45.8334H31.2498C41.6665 45.8334 45.8332 41.6668 45.8332 31.2501V18.7501C45.8332 8.33342 41.6665 4.16675 31.2498 4.16675H18.7498C8.33317 4.16675 4.1665 8.33342 4.1665 18.7501V31.2501C4.1665 41.6668 8.33317 45.8334 18.7498 45.8334Z",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.2915 20.3125C34.0174 20.3125 35.4165 18.9134 35.4165 17.1875C35.4165 15.4616 34.0174 14.0625 32.2915 14.0625C30.5656 14.0625 29.1665 15.4616 29.1665 17.1875C29.1665 18.9134 30.5656 20.3125 32.2915 20.3125Z",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.7085 20.3125C19.4344 20.3125 20.8335 18.9134 20.8335 17.1875C20.8335 15.4616 19.4344 14.0625 17.7085 14.0625C15.9826 14.0625 14.5835 15.4616 14.5835 17.1875C14.5835 18.9134 15.9826 20.3125 17.7085 20.3125Z",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.5 27.7083H32.5C33.5417 27.7083 34.375 28.5416 34.375 29.5833C34.375 34.7708 30.1875 38.9583 25 38.9583C19.8125 38.9583 15.625 34.7708 15.625 29.5833C15.625 28.5416 16.4583 27.7083 17.5 27.7083Z",
    stroke: "#8BC63E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiIcon);
export default __webpack_public_path__ + "static/media/emoji-icon.31ff43338b76ed0da7fb120176dc65b0.svg";
export { ForwardRef as ReactComponent };